import { Component } from '@angular/core';

import { pedidoNaoLiberado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-nao-liberado',
    templateUrl: './pedido-status-badge-nao-liberado.component.html',
    styleUrls: ['./pedido-status-badge-nao-liberado.component.less']
})
export class PedidoStatusBadgeNaoLiberadoComponent {
    status = pedidoNaoLiberado;
}
